/**
 * @generated SignedSource<<ee94a156fd7d69a59077a0677aa07b3f>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CollectorTileContent_nftAuction$data = {
  readonly " $fragmentSpreads": FragmentRefs<"NftItemTileAuctionDetails_nftAuction">;
  readonly " $fragmentType": "CollectorTileContent_nftAuction";
};
export type CollectorTileContent_nftAuction$key = {
  readonly " $data"?: CollectorTileContent_nftAuction$data;
  readonly " $fragmentSpreads": FragmentRefs<"CollectorTileContent_nftAuction">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CollectorTileContent_nftAuction",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NftItemTileAuctionDetails_nftAuction"
    }
  ],
  "type": "NftAuction",
  "abstractKey": null
};

(node as any).hash = "0f72268f11ce71e6ec4f5565ed9b44bf";

export default node;
